export default "__VITE_ASSET__CqaHqvEm__"